import React from 'react'

export default function Skill({skill,removeSkill,id}) {
	return (
		<>
			<li className="remove-list-style"><span>{removeSkill && (<button onClick={()=>removeSkill(id)}><i class="far fa-trash-alt"></i></button>)}</span>{skill.skill}<span className="prof">{skill.prof ? skill.prof+'%' : ''}</span></li>
		</>
	)
}